import { HttpClient } from '../httpClient';
import User from '../models/user';
import { DataResponse } from '../responses/baseResponse';
import TherapistRolesRepsonse from '../responses/therapistRolesResponse';
import TherapistsResponse from '../responses/therapistsResponse';
//import RolesResponse from '../responses/timesheetStatusesResponse';

const httpClient = new HttpClient();

export const getTherapistRoles = async () => {
  return httpClient.get<TherapistRolesRepsonse>({
    url: '/v1/therapistRoles',
    requiresToken: true,
  });
};

export const getTherapists = async () => {
  return httpClient.get<TherapistsResponse>({
    url: '/v1/therapistRoles/Therapists',
    requiresToken: true,
  });
};

export const getTherapistUsers = async () => {
  return httpClient.get<DataResponse<User[]>>({
    url: '/v1/therapistRoles/Therapists/Users',
    requiresToken: true,
  });
};

export const getTherapistsByDisciplineId = async (disciplineId: number) => {
  return httpClient.get<TherapistsResponse>({
    url: `/v1/billing/caseloads/TherapistsByDisciplineId/${disciplineId}`,
    requiresToken: true,
  });
};

export const getTherapistsByDisciplineIds = async (disciplineIds: number[]) => {
  return httpClient.post<DataResponse<User[]>>({
    url: `/v1/billing/caseloads/TherapistsByDisciplineIds/`,
    payload: disciplineIds,
    requiresToken: true,
  });
};

export const getDisciplineGroupTherapistsByDisciplineIds = async (disciplineIds: number[]) => {
  return httpClient.post<DataResponse<User[]>>({
    url: `/v1/billing/caseloads/DisciplineGroupTherapistsByDisciplineIds/`,
    payload: disciplineIds,
    requiresToken: true,
  });
};

export const getTherapistsByRole = async () => {
  return httpClient.get<DataResponse<User[]>>({
    url: '/v1/admin/therapists/byrole/',
    requiresToken: true,
  });
};